import { Box, Flex, Float } from "@chakra-ui/react";
import { getTrackingId, Logo } from "@euka-mfes/bark";
import { LearningClassEnums as CLS } from "@/ts/enums/LearningClassEnums";
import { Outlet } from "react-router-dom";

const ErrorPageLayout = () => {
  return (
    <Flex
      flexDir="column"
      w="full"
      minH="100vh"
      justifyContent="space-between"
      position="relative"
      data-testid="error-page-layout"
    >
      <Float
        placement="top-start"
        offsetX={{ base: "12", md: "14", lg: "16" }}
        offsetY={{ base: "8", md: "9", lg: "10" }}
      >
        <Box
          data-tracking-id={getTrackingId(
            [CLS.ErrorPageLayout, CLS.Link],
            "logo-home"
          )}
        >
          <Logo variant="inline" size="xl" href="/" />
        </Box>
      </Float>
      <Outlet />
    </Flex>
  );
};

export default ErrorPageLayout;
